import { render, staticRenderFns } from "./UserIndex.vue?vue&type=template&id=358aa098&scoped=true&"
import script from "./UserIndex.vue?vue&type=script&lang=js&"
export * from "./UserIndex.vue?vue&type=script&lang=js&"
import style0 from "./UserIndex.vue?vue&type=style&index=0&id=358aa098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358aa098",
  null
  
)

export default component.exports